import React from "react";
import { BRAND_LOGO_SRC, BRAND_NAME } from "../branding";

const BrandLogo = ({ className = "", alt = `${BRAND_NAME} placeholder logo`, ...props }) => {
  return <img className={className} src={BRAND_LOGO_SRC} alt={alt} {...props} />;
};

export default BrandLogo;
